/**
 * Component: Check Compatibility
 * ------------------------------------------------------------------------------
 * Used on the product page to check vehicle compatibility.
 *
 * @namespace checkCompatibility
 */
import cssClasses from '../helpers/cssClasses'
import log from 'salvo-lite/log'

class CheckCompatibility {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem

        this._currentCar = null

        this._settings = {
            notCompatibleLink: null,
            vehicleCodes: [],
            filterModel: [],
            ...JSON.parse(elem.getAttribute('data-check-compatibility'))
        }

        this._selectors = {
            notCompatibleText: '[data-check-compatibility-not-compatible]',
            isCompatibleText: '[data-check-compatibility-is-compatible]',
            tab: '[data-check-compatibility-tab]',
            button: '[data-check-compatibility-button]',
            incompatibleButton: '[data-check-compatibility-incompatible]',
            mobileAccordionHeader: '[data-product-accordions-compatibility]',
            mobileAccordion: '[data-compatibility-accordion]'
        }

        this._nodeSelectors = {
            tab: document.querySelector(this._selectors.tab),
            button: this._elem.querySelector(this._selectors.button),
            notCompatibleText: document.querySelectorAll(this._selectors.notCompatibleText),
            isCompatibleText: document.querySelectorAll(this._selectors.isCompatibleText),
            mobileAccordion: document.querySelector(this._selectors.mobileAccordion),
            mobileAccordionHeader: document.querySelector(this._selectors.mobileAccordionHeader),
            incompatibleButton: document.querySelector(this._selectors.incompatibleButton)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._setEventListeners()
        this._setCurrentCar()
        this._checkCompatibility()
        this._addLink()
    }

    _addLink () {
        if (this._settings.notCompatibleLink !== null) {
            let linkText = 'here'

            if (window.theme.store.id === 'de_store') linkText = 'hier'

            const text = this._nodeSelectors.notCompatibleText[0].innerText.replace('#', `<a href="${this._settings.notCompatibleLink}">${linkText}</a>`)

            this._nodeSelectors.notCompatibleText.forEach((element) => {
                element.innerHTML = text
            })
        }
    }

    _setEventListeners () {
        window.Frame.EventBus.listen([
            'CurrentCar:setCar',
            'CurrentCar:updated',
            'CurrentCar:clear'
        ], () => this._setCurrentCar())

        if (this._nodeSelectors.mobileAccordionHeader) {
            this._nodeSelectors.incompatibleButton.addEventListener('click', () => {
                this._toggleCompatibilityAccordion()
            })
        }
    }

    _setCurrentCar () {
        this._currentCar = window.Frame.CurrentCarCookie.get()
        this._checkCompatibility()
    }

    _checkCompatibility () {
        let isCompatible = false
        if (window.Frame.CurrentCarCookie.isCookieSet()) {
            if (this._currentCar.vehicleCode === false) {
                const replaceString = (window.theme.store.id === 'de_store') ? '-Aktuell' : '-Present'
                const year = this._currentCar.year.split(/\s/).join('').replace(replaceString, '')
                const model = this._currentCar.model
                if (this._settings.filterModels.includes(`${model}_${year}`) || this._settings.filterModels.includes('All_Model')) {
                    isCompatible = true
                }
            } else {
                if (this._settings.vehicleCodes.includes(this._currentCar.vehicleCode) || this._settings.vehicleCodes.includes('All_VehicleCode')) {
                    isCompatible = true
                }
            }

            if (isCompatible) {
                this._elem.classList.add(cssClasses.compatible)
                this._nodeSelectors.tab.classList.add(cssClasses.compatible)
                this._nodeSelectors.tab.classList.remove(cssClasses.incompatible)
                this._nodeSelectors.mobileAccordion.classList.remove(cssClasses.incompatible)
                this._nodeSelectors.isCompatibleText.forEach((element) => element.classList.remove(cssClasses.hidden))
            } else {
                this._elem.classList.add(cssClasses.incompatible)
                this._nodeSelectors.tab.classList.remove(cssClasses.compatible)
                this._nodeSelectors.tab.classList.add(cssClasses.incompatible)
                this._nodeSelectors.mobileAccordion.classList.add(cssClasses.incompatible)
                this._nodeSelectors.isCompatibleText.forEach((element) => element.classList.add(cssClasses.hidden))
            }
            return
        }

        this._elem.classList.remove(cssClasses.compatible)
        this._elem.classList.remove(cssClasses.incompatible)
        this._nodeSelectors.tab.classList.remove(cssClasses.compatible)
        this._nodeSelectors.tab.classList.remove(cssClasses.incompatible)
        this._nodeSelectors.mobileAccordion.classList.remove(cssClasses.incompatible)
        this._nodeSelectors.isCompatibleText.forEach((element) => element.classList.add(cssClasses.hidden))
    }

    _toggleCompatibilityAccordion () {
        this._nodeSelectors.mobileAccordionHeader.classList.add(cssClasses.active)
    }
}

// on click of incompativble, scroll to toggle mobileAccordionHeader

export default CheckCompatibility



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CheckCompatibility.js